import { useEffect, useMemo } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { loadStripeWrapper } from "@/react/hooks/paywalls/useStripeElement";
import type { StripeElementsManagerProps } from "./Props";
import { useOptions } from "./useOptions";

export const StripeElementsManager = ({
  children,
}: StripeElementsManagerProps) => {
  const { processorId, processorKey, setStripeElementsMode } =
    usePaywallCheckoutContext();

  const stripe = useMemo(
    () =>
      loadStripeWrapper({
        stripeAccountId: processorId,
        stripePublicKey: processorKey,
        // TODO: should we use the community's locale instead?
        locale: window.locale,
      }),
    [processorId, processorKey],
  );
  const options = useOptions();
  const stripeElementsMode = options.mode;

  useEffect(() => {
    if (!stripeElementsMode) {
      return;
    }
    setStripeElementsMode(stripeElementsMode);
  }, [setStripeElementsMode, stripeElementsMode]);

  return (
    <Elements stripe={stripe} options={options}>
      {children}
    </Elements>
  );
};
